import { Filter } from "./filter";

export class FilterGroup {
  identifier: number;
  not: boolean;
  constructor(public code: string, public filters: Array<Filter>) {}
}
